import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.typed.uint8-array.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import { decompress } from 'fflate';
var unpackResult = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(storageResp) {
    var taskName,
      _blob,
      arrayBuf,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            taskName = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            if (!(taskName === 'DownloadAnnotSeuratObject' || taskName === 'GetNormalizedExpression')) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return storageResp.blob();
          case 4:
            _blob = _context.sent;
            return _context.abrupt("return", _blob);
          case 6:
            _context.t0 = Uint8Array;
            _context.next = 9;
            return storageResp.arrayBuffer();
          case 9:
            _context.t1 = _context.sent;
            arrayBuf = new _context.t0(_context.t1);
            if (!(taskName === 'CellSets')) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", arrayBuf);
          case 13:
            return _context.abrupt("return", decompressUint8Array(arrayBuf));
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function unpackResult(_x) {
    return _ref.apply(this, arguments);
  };
}();
var decompressUint8Array = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(array) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              decompress(array, function (err, decompressed) {
                if (err) {
                  reject(err);
                } else {
                  resolve(decompressed);
                }
              });
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function decompressUint8Array(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export { decompressUint8Array };
export default unpackResult;